import EmployeesTable from "../Employees/EmployeesTable";

const Assistants = () => {
  return <EmployeesTable role={Assistants} addButtonTitle={"Assistant"} />;
};

export default Assistants;
